import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Tooltip
 *
 * @param props - children, title, placement, open, arrowBorder
 * @example
 * <Tooltip
 * 	id=""
 * 	title={React.ReactNode}
 * 	placement={'bottom-end' || 'bottom-start' || 'bottom' || 'left-end' || 'left-start' || 'left' || 'right-end' || 'right-start' || 'right' || 'top-end' || 'top-start' || 'top'}
 * 	open={true || false}
 * 	arrowBorder={true || false}
 * >
 * 	{children}
 * </Tooltip>
 * @returns React.ReactElement
 */
var Tooltip = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
Tooltip.defaultProps = {};
var SampleProps = {};
export default Tooltip;
export { SampleProps as TooltipSample, };
